import request from "@/utils/request";

export const getModelProviders = () => request({ url: "/user/model-providers", method: "get" });
export const getModelConfigs = () => request({ url: "/user/model-configs", method: "get" });
export const createModelConfig = (data) => request({ url: "/user/model-configs", method: "post", data });
export const updateModelConfig = (id, data) => request({ url: `/user/model-configs/${encodeURIComponent(id)}`, method: "put", data });
export const deleteModelConfig = (id) => request({ url: `/user/model-configs/${encodeURIComponent(id)}`, method: "delete" });
